export enum ActivityLogSort {
  CREATED = 'created',
  CREATED_DESC = '-created',
  VENUE_NAME = 'venueName',
  VENUE_NAME_DESC = '-venueName',
}

export enum ActivityLogChangeType {
  CREATED_DOCUMENT = 'CREATED_DOCUMENT',
  UPDATED_DOCUMENT = 'UPDATED_DOCUMENT',
  DELETED_DOCUMENT = 'DELETED_DOCUMENT',
}

export enum ActivityLogChangeTypeName {
  CREATED_DOCUMENT = 'Created Document',
  UPDATED_DOCUMENT = 'Updated Document',
  DELETED_DOCUMENT = 'Deleted Document',
}

export enum ActivityLogPropertyChangeType {
  ADDED_PROPERTY = 'ADDED_PROPERTY',
  DELETED_PROPERTY = 'DELETED_PROPERTY',
  UPDATED_PROPERTY = 'UPDATED_PROPERTY',
}

export enum ActivityLogPropertyChangeTypeName {
  ADDED_PROPERTY = 'Added Property',
  DELETED_PROPERTY = 'Deleted Property',
  UPDATED_PROPERTY = 'Updated Property',
}

export enum ActivityLogDocumentType {
  ADMISSION_GROUP = 'ADMISSION_GROUP',
  INVENTORY = 'INVENTORY',
  VENUE = 'VENUE',
  CUSTOMER = 'CUSTOMER',
  ORGANIZATION = 'ORGANIZATION',
  MANAGEMENT_USER = 'MANAGEMENT_USER',
  REPORT = 'REPORT',
  INTEGRATION = 'INTEGRATION',
  PERMISSION = 'PERMISSION',
  EVENT = 'EVENT',
}

export enum ActivityLogEvent {
  OBJECT_CREATED = 'OBJECT_CREATED',
  OBJECT_UPDATED = 'OBJECT_UPDATED',
  OBJECT_DELETED = 'OBJECT_DELETED',
}

export enum ActivityLogActorType {
  STAFF = 'STAFF',
  ADMIN = 'ADMIN',
  CUSTOMER = 'CUSTOMER',
  PROMOTER = 'PROMOTER',
}

export const ActivityLogActorTypeLabels: Record<ActivityLogActorType, string> =
  {
    [ActivityLogActorType.STAFF]: 'Staff',
    [ActivityLogActorType.ADMIN]: 'Admin',
    [ActivityLogActorType.CUSTOMER]: 'Customer',
    [ActivityLogActorType.PROMOTER]: 'Promoter',
  }

export const ActivityLogActorTypeFilterOrder: ActivityLogActorType[] = [
  ActivityLogActorType.STAFF,
  ActivityLogActorType.ADMIN,
  ActivityLogActorType.PROMOTER,
  ActivityLogActorType.CUSTOMER,
]

export const ActivityLogDocumentTypeLabels: Record<
  ActivityLogDocumentType,
  string
> = {
  [ActivityLogDocumentType.ADMISSION_GROUP]: 'Admission/Res',
  [ActivityLogDocumentType.INVENTORY]: 'Inventory',
  [ActivityLogDocumentType.VENUE]: 'Venue',
  [ActivityLogDocumentType.CUSTOMER]: 'Customer',
  [ActivityLogDocumentType.ORGANIZATION]: 'Organization',
  [ActivityLogDocumentType.MANAGEMENT_USER]: 'Staff/Promoter',
  [ActivityLogDocumentType.REPORT]: 'Report',
  [ActivityLogDocumentType.INTEGRATION]: 'Integration',
  [ActivityLogDocumentType.PERMISSION]: 'Permission',
  [ActivityLogDocumentType.EVENT]: 'Event',
}
